import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Drawer, List, Typography,
} from '@mui/material';
// eslint-disable-next-line import/no-cycle
import FilterField from './filterField';
import ListerContext from '../../context';

const WIDTH = 540; // 340px

function FilterPanel({
  filteringFields, show, filter, onSetFilter,
}) {
  const { actions } = useContext(ListerContext);
  return (
    <Drawer
      open={show}
      anchor="right"
      onClose={actions.onToggleFilterOpened}

    >
      <List
        sx={{ width: WIDTH }}
        subheader={(
          <Typography align="center" gutterBottom variant="h4">Фільтрування</Typography>
      )}
      >
        {filteringFields.map((ff) => (
          <FilterField
            key={ff.name}
            desc={ff}
            value={filter[ff.name]}
            onSetFilter={onSetFilter}
          />
        ))}
      </List>
    </Drawer>
  );
}

FilterPanel.propTypes = {
  filteringFields: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    resource: PropTypes.string,
  })).isRequired,
  show: PropTypes.bool.isRequired,
  filter: PropTypes.shape({}).isRequired,
  onSetFilter: PropTypes.func.isRequired,
};

export default FilterPanel;
